export default __webpack_public_path__ + "static/media/fixedBalloon00.12d58dad.gif";